<template>
  <div class="car-popup-modal relative">
    <div class="modal-scroll w-full overflow-auto h-[calc(100vh-75px)] md:h-[calc(100vh-100px)] lg:pr-1">
      <form method="dialog">
        <button class="bg-white w-9 h-9 rounded-full shadow-md fixed text-md z-50 !top-4 !left-4 lg:hidden border-0" style="outline:none !important;"><i class="fa-solid fa-angle-left"></i></button>
        <button class="w-10 h-10 bg-white rounded-full absolute text-3xl z-50 hidden !top-1 !right-2 lg:block modal-close-content"><i class="fa-solid fa-xmark"></i></button>
      </form>
      <div class="modal-slider car-img-slider-pop rounded-lg lg:hidden" id="modal-slider-1">
        <div class="car-img" v-if="car.images.length > 0" v-for="(image, key) in car.images">
          <img class="w-full h-auto lazyload" src="/img/sub_car_placeholder_new.png" :data-src="image.thumb" @error="replaceByDefault" >
        </div>
        <div v-else>
          <img class="w-full h-auto"  src="/img/sub_car_placeholder_new.png">
        </div>
      </div>
      <div class="px-6 md:px-14 md:py-7 lg:px-0 lg:py-0 py-[21px]">
        <div class="lg:flex">
          <div class="hidden lg:mr-3 lg:w-3/6 lg:block relative">
            <div  class="dektop-popup-slider car-img-slider-pop" id="dektop-popup-slider-1">
              <div class="car-img" v-if="car.images.length > 0" v-for="(image, key) in car.images">
                <img class="w-full h-auto lazyload" src="/img/sub_car_placeholder_new.png" :data-src="image.thumb" @error="replaceByDefault" >
              </div>
              <div v-else>
                <img class="w-full h-auto"  src="/img/sub_car_placeholder_new.png">
              </div>
            </div>
            <div class="top-left absolute left-2 top-2" v-if="car.tags.length">
              <ul class="flex flex-wrap gap-1">
                <li v-for="(tag, key) in car.tags" :key="key" :class="`bg-[${tag.color}]`" class="rounded-sm font-semibold text-white text-center bg-[#A9BD2F] text-[10px] py-[2px] px-[6px]">{{ $t(`car.tags.${tag.label}`) }}</li>
              </ul>
            </div>
          </div>
          <div class="lg:ml-3 lg:w-3/6">
            <div class="relative" :class="{'border-b pb-4': !isSubscriptionPage}"><span class="leading-6 pb-1 font-medium text-[#84889A] text-[13px] uppercase tracking-wider">{{ (car.type.name[appLocale]) }}</span>
              <h3 class="text-dark-blue-2 leading-8 pb-2 font-semibold flex items-center text-[26px] md:font-bold max-lg:justify-between max-w-80">
                <span>{{car.brand.name}}&nbsp{{ car.model.name}}</span>
<!--                Logic to put energy class badge here. To be done in future-->
                <span class="w-8 h-8 rounded-full border-2 border-lime-500 inline-flex ml-4" v-if="1===0">
                  <span class="bg-lime-500 rounded-full w-full h-full text-sm font-bold border-2 text-white border-white justify-center items-center inline-flex">4</span>
                </span>
              </h3>
              <span class="location flex text-base items-center gap-2 text-dark-blue-2 " :class="{'mb-1': !isSubscriptionPage, 'font-medium': isSubscriptionPage}">
                <span><img :src="versionAsset('/assets/shared/img/icons/location-pin.svg')" alt="location-pin"></span>
                {{ getClosestDepartment(car).name[appLocale] }}
              </span>
              <span class="location-map flex text-base items-center gap-2 text-dark-blue-2 font-normal mb-1" v-if="!isSubscriptionPage && car.distanceFromClosestLocation >= 0.1">
                <span><img src="/assets/customer-v3/img/pin-distance-line.svg" alt="location-pin"></span>
                {{ $t('layout.distance_away_from_department', { km: car.distanceFromClosestLocation, department: postal, distanceUnitShort: distanceUnitShort }) }}
              </span>
            </div>
            <div class="border-b py-4 border-[#D9DBE1] pt-[18px]" v-if="isSubscriptionPage">
              <p class="text-base font-normal leading-5 text-date">{{ $t('layout.labels.subscription.available_from') }}
                <span class="font-semibold !text-[#208E00]">{{ formatDate(getAvailableFrom(car)) }}</span>
              </p>
            </div>
            <div class="border-b pt-4 pb-6 border-[#D9DBE1] lg:border-0 lg:pb-0">
              <ul class="flex flex-wrap gap-5 mb-6">
                <li v-if="car.seats" class="text-base text-dark-blue-2 font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5"><img :src="versionAsset('/assets/shared/img/icons/avtar.svg')" alt="avtar"></span>
                  {{ car.seats + ' ' + $t('inputs.car.seats') }}
                </li>
                <li v-if="car.fuel_type_original" :class="{'text-dark-blue-2': car.fuel_type_original != 'electric', 'text-[#00AEB9]': car.fuel_type_original == 'electric'}" class="text-base font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5">
                    <img :src="versionAsset(car.fuel_type_original != 'electric' ? '/assets/shared/img/icons/diesel.svg' : '/assets/shared/img/icons/electric-icon.svg')" :alt="car.fuel_type_original">
                  </span>
                  {{ $t('admin.labels.'+car.fuel_type_original) || '-' }}
                </li>
                <li  v-if="car.doors" class="text-base text-dark-blue-2 font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5">
                    <img :src="versionAsset('/assets/shared/img/icons/doors.svg')" :alt="$t('inputs.car.doors')">
                  </span> {{ car.doors + ' ' + $t('inputs.car.doors') }}
                </li>
                <li v-if="car.transmission_original" class="text-base text-dark-blue-2 font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5"><img :src="versionAsset('/assets/shared/img/icons/automatic.svg')" :alt="car.transmission_original"></span>
                  {{ $t('admin.labels.' + car.transmission_original) || '-' }}
                </li>
                <li v-if="car.mileage" :class="{'text-dark-blue-2': car.fuel_type_original != 'electric', 'text-[#00AEB9]': car.fuel_type_original == 'electric'}" class="text-base font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5"><img :src="versionAsset(car.fuel_type_original == 'electric' ? '/assets/subscription/img/km-blue-icon.svg' : '/assets/subscription/img/km-icon.svg')" alt="automatic"></span>
                  {{ car.mileage }} {{ car.fuel_type_original != 'electric' ? carMileageUnits : $t('layout.labels.km_range', {distanceUnitShort: distanceUnitShort}) }}
                </li>
                <li v-if="car.has_tow_hook"  class="text-base text-dark-blue-2 font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5"><img :src="versionAsset('/assets/shared/img/icons/towhook.svg')" alt="automatic"></span>
                  {{ $t('layout.labels.with_tow_hook') }}
                </li>
                <li v-if="!car.has_tow_hook"  class="text-base text-dark-blue-2 font-medium leading-5 flex items-center gap-3 w-auto">
                  <span class="leading-5"><img :src="versionAsset('/assets/shared/img/icons/no-towhook.svg')" alt="automatic"></span>
                  {{ $t('layout.labels.no_towbar') }}
                </li>
              </ul>
              <div v-if="hasAgeRestriction()" class="mt-2 w-full px-3 py-2 bg-amber-100 rounded-lg justify-start items-center gap-2 inline-flex">
                <div class="w-7 h-7 relative"><img :src="versionAsset('/assets/subscription/img/warning-icon.svg')"></div>
                <div class="grow shrink basis-0 flex-col justify-start items-start inline-flex gap-0.5">
                  <div class="text-yellow-800 text-sm font-semibold leading-none">{{ $t('layout.labels.subscription.only_for_driver', { age:  car.props.age_restriction}) }}</div>
                </div>
              </div>
              <a v-if="!isSubscriptionPage" class="flex gap-1.5 md:hidden px-0 text-sm items-center text-light-blue-2 mt-5 mb-1" href="javascript:void(0)" @click="showModal('my_information', car)">
                <svg width="18" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 2.46655C5.90496 2.46655 2.16663 6.20489 2.16663 10.7999C2.16663 15.3949 5.90496 19.1332 10.5 19.1332C15.095 19.1332 18.8333 15.3949 18.8333 10.7999C18.8333 6.20489 15.095 2.46655 10.5 2.46655ZM10.5 17.4666C6.82413 17.4666 3.83329 14.4757 3.83329 10.7999C3.83329 7.12405 6.82413 4.13322 10.5 4.13322C14.1758 4.13322 17.1666 7.12405 17.1666 10.7999C17.1666 14.4757 14.1758 17.4666 10.5 17.4666Z" fill="#545D78"></path>
                  <path d="M9.66663 9.96663H11.3333V14.9666H9.66663V9.96663ZM9.66663 6.6333H11.3333V8.29997H9.66663V6.6333Z" fill="#545D78"></path>
                </svg>
                <p class="border-b border-light-blue-2 font-semibold">
                  {{ $t('layout.labels.important_information') }}
                </p>
              </a>
            </div>
          </div>
        </div>
        <div class="border-b pt-5 pb-6 border-[#D9DBE1] lg:pt-0 xl:pt-5">
          <h4 class="text-black font-semibold leading-6 text-[22px] mb-[26px] md:text-[26px]">{{ isSubscriptionPage ? $t('layout.labels.subscription.included_in_subscription') : $t('layout.labels.included_in_rental')}}</h4>
          <div class="lg:flex lg:flex-wrap">
            <div class="flex gap-4 items-start pb-[26px] lg:w-3/6">
              <img :class="{'w-[22px] h-[22px]': !isSubscriptionPage}" :src='versionAsset("/assets/shared/img/icons/kilometer.svg")' alt="kilometer">
              <div v-if="car.km_included">
                <h6 class="text-dark-blue-2 font-semibold leading-5 mb-1">{{ isSubscriptionPage ? $t('layout.labels.subscription.km_per_month_heading', { km:  car.subscription_included_km, distanceUnitShort: distanceUnitPlural}) : $t('layout.value_km_driving', {'distanceUnitShort': distanceUnitPlural, 'km': getCarInfo(car.id).is_long_booking ? car.long_term_km_included : car.km_included }) }} </h6>
                <p class="leading-4 text-sm font-normal text-light-blue-2">{{ isSubscriptionPage ? $t('layout.labels.subscription.km_per_month_description', { km:  car.subscription_included_km, distanceUnitShort: distanceUnitPlural}) : $t( getCarInfo(car.id).is_long_booking ? 'layout.value_km_driving_paragraph_longterm' : 'layout.value_km_driving_paragraph', {distanceUnitLong: distanceUnitPlural}) }}</p>
              </div>
            </div>
            <div class="flex gap-4 items-start pb-[26px] lg:w-3/6">
              <img :class="{'w-[22px] h-[22px]': !isSubscriptionPage}" src="/assets/shared/img/icons/insurance.svg" alt="insurance">
              <div>
                <h6 class="text-dark-blue-2 font-semibold leading-5 mb-1">{{ $t('layout.labels.subscription.basic_insurance') }}</h6>
                <p class="leading-4 text-sm font-normal text-light-blue-2">{{ $t('layout.labels.subscription.basic_insurance_desc') }}</p>
              </div>
            </div>
            <div class="flex gap-4 items-start pb-[26px] lg:w-3/6">
              <img :class="{'w-[22px] h-[22px]': !isSubscriptionPage}" src="/assets/shared/img/icons/roadside-assistance.svg" alt="roadside-assistance">
              <div>
                <h6 class="text-dark-blue-2 font-semibold leading-5 mb-1">{{ $t('layout.labels.subscription.roadside_assistance') }}</h6>
                <p class="leading-4 text-sm font-normal text-light-blue-2">{{ $t('layout.labels.subscription.roadside_assistance_desc') }}</p>
              </div>
            </div>
            <div v-if="isSubscriptionPage" class="flex gap-4 items-start lg:w-3/6">
              <img src="/assets/subscription/img/extra-drivers.svg" alt="extra-drivers">
              <div>
                <h6 class="text-dark-blue-2 font-semibold leading-5 mb-1">{{ $t('layout.labels.subscription.upto_3_extra_drivers') }}</h6>
                <p class="leading-4 text-sm font-normal text-light-blue-2">{{ $t('layout.labels.subscription.upto_3_extra_drivers_desc') }}</p>
              </div>
            </div>
            <div v-if="!isSubscriptionPage && getClosestDepartment(car).key_box" class="flex gap-4 items-start lg:w-3/6">
              <img class="w-[22px] h-[22px]" src="/assets/shared/img/icons/keybox.svg" alt="keybox">
              <div>
                <h6 class="text-dark-blue-2 font-semibold leading-5 mb-1">{{ $t('layout.can_be_delivered_outside_opening_hours') }}</h6>
                <p class="leading-4 text-sm font-normal text-light-blue-2">{{ $t('layout.can_be_delivered_outside_opening_hours_paragraph') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="border-b pt-5 pb-6 border-[#D9DBE1]" v-if="isSubscriptionPage">
          <h4 class="text-black font-bold leading-6 mb-6 text-[22px] md:text-[26px]">{{ $t('layout.labels.subscription.commitments') }}</h4>
          <span class="text-light-blue-2 text-sm leading-5 font-medium md:text-base">{{ getCommitments(car) }}</span>
        </div>
        <div class="border-b pt-5 pb-6 border-[#D9DBE1] features-option" v-if="car.features.length > 0">
          <h4 class="text-black font-bold leading-6 mb-6 text-[22px] md:text-[26px]">{{ $t('layout.labels.subscription.vehicle_features') }}</h4>
          <ul class="flex gap-2 flex-wrap all-data-feature">
            <li v-for="(value, index) in car.features" class="bg-grey-2 font-medium text-sm leading-4 text-date px-4 rounded-full py-[10px]" :class="{ 'cursor-pointer show-content hidden': index > 8 }">{{value[appLocale]}}</li>
          </ul>
          <div class="mt-4" v-if="car.features.length > 9">
            <a class="cursor-pointer text-sm font-bold leading-4 underline text-dark-blue-2 all-feature-show toggle-classes" href="javascript:void(0);">{{ $t('layout.labels.subscription.show_all_features', {features_count:  car.features.length}) }}
              <i class="fa-solid fa-chevron-down pl-2"></i>
            </a>
          </div>
        </div>
        <div class="border-b pt-5 pb-6 border-[#D9DBE1]" v-if="hasSeasonalPrices">
          <h4 class="text-black font-bold leading-6 mb-3 text-[22px] md:text-[26px]">{{ $t('layout.rental.day_prices') }}</h4>
          <p class="text-light-blue-2 text-sm font-normal mb-6"> {{ $t('layout.rental.day_prices_para') }}</p>
          <div class="w-full">
            <table class="min-w-full table-fixed border-separate border-spacing-0 text-center text-gray-700">
              <thead>
              <tr>
                <th class="bg-white w-10 rounded-tl-lg"></th>
                <th class="border border-gray-300 px-4 py-3 font-bold bg-gray-100 rounded-tl-lg whitespace-normal break-words max-w-0">{{ $t('form_car.seasonal_prices.low_season') }}</th>
                <th class="border border-gray-300 px-4 py-3 font-bold bg-gray-100 rounded-tr-lg whitespace-normal break-words max-w-0">{{ $t('form_car.seasonal_prices.high_season') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="md:w-1/3 w-1/6 px-6 py-3 border border-gray-300 font-medium bg-gray-100 rounded-tl-lg uppercase whitespace-normal break-words">{{ $t('form_car.seasonal_prices.week_days') }}</td>
                <td class="border border-gray-300 px-4 py-2 whitespace-normal break-words max-w-0">{{ formatPrice(seasonalPrices.low_season_weekday) }}</td>
                <td class="border border-gray-300 px-4 py-2 whitespace-normal break-words max-w-0">{{ formatPrice(seasonalPrices.high_season_weekday) }}</td>
              </tr>
              <tr>
                <td class="md:w-1/3 w-1/6 border border-gray-300 px-6 py-3 font-medium bg-gray-100 uppercase whitespace-normal break-words">{{ $t('form_car.seasonal_prices.weekends') }}</td>
                <td class="border border-gray-300 px-4 py-2 whitespace-normal break-words max-w-0">{{ formatPrice(seasonalPrices.low_season_weekend) }}</td>
                <td class="border border-gray-300 px-4 py-2 whitespace-normal break-words max-w-0">{{ formatPrice(seasonalPrices.high_season_weekend) }}</td>
              </tr>
              <tr>
                <td class="md:w-1/3 w-1/6 border border-gray-300 px-6 py-3 font-medium bg-gray-100 rounded-bl-lg uppercase whitespace-normal break-words">{{ $t('form_car.seasonal_prices.special_days') }}</td>
                <td class="border border-gray-300 px-4 py-2 whitespace-normal break-words max-w-0">{{ formatPrice(seasonalPrices.low_season_holiday) }}</td>
                <td class="border border-gray-300 px-4 py-2 rounded-br-lg whitespace-normal break-words max-w-0">{{ formatPrice(seasonalPrices.high_season_holiday) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <p class="text-xs mt-4 font-normal text-light-blue-2">{{ $t('layout.rental.nonbinding_prices') }}</p>
        </div>
        <div class="border-b pt-5 pb-6 border-[#D9DBE1]" v-if="isSubscriptionPage">
          <h4 class="text-black font-bold leading-6 mb-4 text-[22px] md:text-[26px]">{{ $t('layout.labels.subscription.commitment_prices') }}</h4>
          <p class="text-sm leading-6 font-normal text-tag-grey mb-4 md:text-base">{{ $t('layout.labels.subscription.commitment_prices_desc') }}</p>
          <div class="relative overflow-x-auto table-list">
            <table class="w-full text-sm text-center text-gray-500 rtl:text-right max-w-[500px]">
              <tbody>
              <tr class="border-b border-[#C6CDE1]" v-if="car.subscription_prices.calculated.hasOwnProperty('adjustment_12_months_tier')">
                <th class="text-center uppercase border py-3 px-4 font-medium whitespace-nowrap text-black leading-4 w-[50%] border-[#C6CDE1] bg-[#F7F7F7] text-[13px]" scope="row">{{ $t('layout.labels.subscription.subscription_x_months', {'months': 12}) }}</th>
                <td class="py-3 px-4 text-sm text-black border leading-6 text-center w-[50%] border-[#C6CDE1]">
                  {{ formatPrice(normalizePriceToApp(car.subscription_prices.calculated.adjustment_12_months_tier)) }}
                </td>
              </tr>
              <tr class="border-b border-[#C6CDE1]" v-if="car.subscription_prices.calculated.hasOwnProperty('adjustment_6_months_tier')">
                <th class="text-center uppercase border py-3 px-4 font-medium whitespace-nowrap text-black leading-4 w-[50%] border-[#C6CDE1] bg-[#F7F7F7] text-[13px]" scope="row">{{ $t('layout.labels.subscription.subscription_x_months', {'months': 6}) }}</th>
                <td class="py-3 px-4 text-sm text-black border leading-6 text-center w-[50%] border-[#C6CDE1]">
                  {{ formatPrice(normalizePriceToApp(car.subscription_prices.calculated.adjustment_6_months_tier)) }}
                </td>
              </tr>
              <tr v-if="car.subscription_prices.calculated.hasOwnProperty('adjustment_3_months_tier')">
                <th class="text-center uppercase border py-3 px-4 font-medium whitespace-nowrap text-black leading-4 w-[50%] border-[#C6CDE1] bg-[#F7F7F7] text-[13px]" scope="row">{{ $t('layout.labels.subscription.subscription_x_months', {'months': 3}) }}</th>
                <td class="py-3 px-4 text-sm text-black border leading-6 text-center w-[50%] border-[#C6CDE1]">
                  {{ formatPrice(normalizePriceToApp(car.subscription_prices.calculated.adjustment_3_months_tier)) }}
                </td>
              </tr>
              </tbody>
            </table>
          </div><span class="text-xs text-[#252525]">{{ $t('layout.labels.subscription.month_price_includes_desc', { km:  car.subscription_included_km, distanceUnitShort: distanceUnitShort}) }}</span>
        </div>
        <div v-if="hasInsideMeasurements() || hasOutterMeasurements()" class="border-b pt-5 pb-6 border-[#D9DBE1]">
          <h4 class="text-black font-bold leading-6 mb-4 text-[22px] md:text-[26px]">{{ $t('layout.labels.subscription.measurements') }}</h4>
          <div class="block md:flex">
            <div class="md:pr-4 md:w-1/2 xl:pr-12" v-if="hasOutterMeasurements()" >
              <h5 class="font-semibold leading-6 text-black py-6 text-[18px]">{{ $t('layout.labels.subscription.outside_measure') }}</h5>
              <img class="mb-3" v-for="img in car.type.outside_measurement_images" v-if="car.type.outside_measurement_images"
                   :src="'/img/admin/cars/car_types_subscription_customer/'+img" alt="outside-measurements">
              <table class="w-full text-base text-gray-500 rounded-lg rtl:text-right">
                <tbody>
                  <tr v-for="measurement in measurements.outside">
                    <template v-if="measurement.measurement !== undefined">
                      <th class="pt-3 text-left font-semibold whitespace-nowrap text-base text-black leading-4" scope="row"> {{ measurement.text }} </th>
                      <td class="pt-3 text-base text-black font-medium leading-6 text-right">{{ Math.round(measurement.measurement * 100)/100 }}{{ lengthUnit }}</td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="md:pl-4 max-md:pt-4 md:w-1/2" v-if="hasInsideMeasurements()">
              <h5 class="font-semibold leading-6 text-black py-6 text-[18px]">{{ $t('layout.labels.subscription.inside_measure') }}</h5>
              <img class="mb-3" v-for="img in car.type.inside_measurement_images" v-if="car.type.inside_measurement_images"
                   :src="'/img/admin/cars/car_types_subscription_customer/'+img" alt="inside-measurements">
              <table class="w-full text-base text-gray-500 rounded-lg rtl:text-right">
                <tbody>
                  <tr v-for="(measurement, key) in measurements.inside">
                    <template v-if="measurement.measurement !== undefined">
                      <th class="pt-3 text-left font-semibold whitespace-nowrap text-base text-black leading-4" scope="row"> {{ measurement.text }} </th>
                      <td class="pt-3 text-base text-black font-medium leading-6 text-right">{{ Math.round(measurement.measurement * 100)/100 }} {{ key === 'capacity' ? lengthCalculationUnit : lengthUnit }}</td>
                    </template>
                  </tr>
                  <tr v-if="car.props.tow_hook_load > 0">
                    <th class="pt-3 text-left font-semibold whitespace-nowrap text-base text-black leading-4" scope="row"> {{ $t('form_car.tow_hook.textbox_label') }} </th>
                    <td class="pt-3 text-base text-black font-medium leading-6 text-right">{{ car.props.tow_hook_load }} {{ massUnit }}</td>
                  </tr>
                  <tr v-if="car.props.max_load && car.props.max_load > 0">
                    <th class="pt-3 text-left font-semibold whitespace-nowrap text-base text-black leading-4" scope="row"> {{ $t('layout.labels.max_load') }} </th>
                    <td class="pt-3 text-base text-black font-medium leading-6 text-right">{{ car.props.max_load }} {{ massUnit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="border-b pt-5 pb-6 border-[#D9DBE1]">
          <div class="flex items-center mb-[30px] max-lg:justify-between">
            <h4 class="text-3xl text-black font-bold leading-6 md:text-3xl">Oscar {{ getClosestDepartment(car).name[appLocale] }}</h4>
            <img :src="versionAsset('/assets/subscription/img/location.svg')" alt="location" class="ml-[14px]">
          </div>
          <div class="md:flex">
            <div class="md:pr-4 md:w-3/6">
              <h6 class="font-bold text-15 text-black mb-4 leading-[18px]">{{ $t('layout.labels.subscription.opening_times') }}</h6>
              <table class="w-full text-base text-gray-500 rounded-lg mb-6 rtl:text-right">
                <tbody>
                <template v-if="getCollectiveDaysTime !== false">
                  <tr class="flex">
                    <th class="pt-2 text-left font-semibold whitespace-nowrap text-base text-date leading-6 w-1/2" scope="row">{{ $t(`layout.labels.subscription.monday_to_friday`) }}</th>
                    <td class="pt-2 text-base text-date font-medium leading-6 text-left w-1/2">
                      <span v-html="getCollectiveDaysTime" />
                    </td>
                  </tr>
                  <tr v-for="day in weekdayName.filter(dayObj => dayObj.index === 6 || dayObj.index === 0 || dayObj.index === 'holiday')" class="flex">
                    <th class="pt-2 text-left flex align-start font-semibold whitespace-nowrap text-base text-date leading-6 w-1/2" scope="row">{{ $t(`layout.days.${day.day}`) }}</th>
                    <td class="pt-2 text-base text-date font-medium leading-6 text-left flex w-1/2">
                      <span class="flex text-center" v-html="getOpeningTime(day.index)" />
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="day in weekdayName" class="flex">
                    <th class="pt-2 text-left font-semibold whitespace-nowrap text-base text-date leading-6 w-1/2" scope="row">{{ $t(`layout.days.${day.day}`) }}</th>
                    <td class="pt-2 text-base text-date font-medium leading-6 text-left flex w-1/2">
                      <span class="flex text-center" v-html="getOpeningTime(day.index)" />
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
              <div class="mt-6">
                <h6 class="font-bold text-15 mb-4 text-black leading-6">{{ $t('layout.labels.subscription.address') }}</h6>
                <div class="text-base text-date leading-6 font-medium mb-4">
                  <template v-if="americanAddressFormat">
                    <template v-if="getClosestDepartment(car).address_extension">
                      {{ getClosestDepartment(car).address }}, {{ getClosestDepartment(car).address_extension }}<br>
                    </template>
                    <template v-else>
                      {{ getClosestDepartment(car).address }}<br>
                    </template>
                    {{ getClosestDepartment(car).city.name && getClosestDepartment(car).city.name[appLocale] }}, {{ getClosestDepartment(car).state }} {{ getClosestDepartment(car).zipcode }}
                  </template>
                  <template v-else>
                    {{ getClosestDepartment(car).address }}
                    <br>{{ getClosestDepartment(car).zipcode }} {{ getClosestDepartment(car).city.name && getClosestDepartment(car).city.name[appLocale] }}
                  </template>
                </div>
              </div>
            </div>
            <div class="md:pl-4 md:w-3/6">
              <div class="map-location">
                <a :href="getClosestDepartment(car).google_maps_url" v-if="getClosestDepartment(car).google_maps_image_src" target="_blank">
                  <img :src="getClosestDepartment(car).google_maps_image_src" class="img-fluid">
                </a>
                <iframe v-if="!getClosestDepartment(car).google_maps_image_src" async defer :src="`https://www.google.com/maps/embed/v1/place?key=${mapsApiKey}&q=${getDepartmentName(car).replaceAll(' ', '+')}`" referrerpolicy="no-referrer-when-downgrade" frameborder="0" width="100%" height="260" allowfullscreen="" loading="lazy"></iframe>
              </div>
              <template v-if="departmentGoogleData.isFetched">
                <GoogleRating v-if="departmentGoogleData.google_rating > 0" :stats="departmentGoogleData" />
                <div v-if="departmentGoogleData.google_rating <= 0 && trustPilotBusinessId" class="py-2">
                  <div class="trustpilot-widget" :data-locale="`${appLocale}-${countryIso}`" data-template-id="5419b6a8b0d04a076446a9ad" :data-businessunit-id="trustPilotBusinessId" data-style-height="24px" data-style-width="100%" data-theme="light">
                    <a :href="trustPilotLink" target="_blank" rel="noopener">Trustpilot</a>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="relative">
          <a target="_blank" v-if="termsAndConditionPage !== ''" download :href="termsAndConditionPage">
            <div class="border-b pt-5 pb-6 flex justify-between items-center cursor-pointer border-[#D9DBE1]">
              <div>
                  <h4 class="text-black font-bold leading-6 mb-4 text-[22px]">{{ $t('layout.labels.subscription.terms_and_conditions') }}</h4>
              </div>
              <img class="pr-1" src="/img/download.svg" alt="download"/>
            </div>
          </a>
          <dialog class="modal backdrop-color" id="terms-condition-modal">
            <div class="modal-box terms-and-conditions !w-full !rounded-none !p-0">
              <form class="flex justify-center border-b px-7 text-dark-blue-2 sticky top-0 w-full bg-white left-0 py-[18px]" method="dialog">
                <button class="absolute rounded-full left-[29px]"><i class="fa-solid fa-xmark text-xl"></i></button>
                <p class="leading-6 font-bold text-center text-[17px]">{{ $t('layout.labels.subscription.terms_and_conditions') }}</p>
              </form>
              <div class="py-8 px-6 max-md:pb-20" v-html="termsAndConditionContent">

              </div>
            </div>
            <form class="modal-backdrop" method="dialog">
              <button><i class="fa-solid fa-xmark text-xl"></i></button>
            </form>
          </dialog>
          <div class="border-b pt-5 pb-6 flex justify-between items-center cursor-pointer border-[#D9DBE1] last-item" @click="showModal('cancellation-policy')">
            <div>
              <h4 class="text-black font-bold leading-6 mb-4 text-[22px]">{{ $t('layout.labels.subscription.cancellation_policy.heading') }}</h4>
            </div><i class="fa-solid fa-chevron-right pr-1"></i>
          </div>
          <dialog class="modal backdrop-color" id="cancellation-policy">
            <div class="modal-box cancelation-policy !w-full !rounded-none !p-0">
              <form class="flex justify-center border-b px-7 text-dark-blue-2 sticky top-0 w-full bg-white left-0 py-[18px]" method="dialog">
                <button class="absolute rounded-full left-[29px]"><i class="fa-solid fa-xmark text-xl"></i></button>
                <p class="leading-6 font-bold text-center text-[17px]">{{ $t('layout.labels.subscription.cancellation_policy.heading') }}</p>
              </form>
              <div class="py-8 px-6 max-md:pb-20" v-html="cancellationPolicyContent">

              </div>
            </div>
            <form class="modal-backdrop" method="dialog">
              <button><i class="fa-solid fa-xmark text-xl"></i></button>
            </form>
          </dialog>
        </div>
        <div class="sticky -bottom-5 left-0 right-0 py-3 w-full bg-white border-t z-50 left-0 right-0 mx-auto price-box md:py-7 max-w-[940px] hidden lg:block !w-full lg:rounded-br-3xl lg:rounded-bl-3xl">
          <div class="flex justify-between items-center hover-btn-orange">
            <div v-if="isSubscriptionPage">
              <p class="text-sm text-dark-blue-2 font-normal leading-4 md:text-base">{{ $t('layout.subscription.from') }}
                <span class="font-bold text-base leading-5 md:text-2xl">{{ formatPrice(getCarTotalAmount(car)) }}</span>&nbsp; {{ $t('layout.subscription.price_per_month') }}
              </p>
              <span class="text-sm text-dark-blue-2 font-medium leading-4 md:text-base">{{ getCommitments(car) }}</span>
            </div>
            <div v-if="!isSubscriptionPage">
              <p class="text-lg text-dark-blue-2 font-normal leading-4 flex gap-2 md:text-base items-end">
                <span class="font-bold text-lg md:text-2xl !leading-none">{{ formatPrice(getCarTotalAmount(car, 'rental')) }}</span>
                <span v-if="getCarInfo(car.id).days_discount" class="text-xs text-light-blue-2 font-normal text-right line-through leading-[16.8px]">{{ formatPrice(Math.round(getCarTotalAmount(car, 'rental') - getCarInfo(car.id).days_discount_amount)) }}</span>
              </p>
              <span class="text-sm text-dark-blue-2 font-medium leading-4 md:text-base underline">{{ generateDateRange() }}</span>
            </div>
            <form :action="getFormRoute()" @submit.prevent="trackActionAndSubmit('select_item', car, $event)" method="GET">
              <input type="hidden" name="car_id" :value="car.id" />
              <input type="hidden" name="department_id" :value="this.getClosestDepartment(car).id" />
              <input type="hidden" name="age" :value="this.age" />
              <input v-if="isSubscriptionPage" type="hidden" name="starting_from" :value="getBookingStartingFrom()" />
              <input type="hidden" name="car_position_in_list" :value="this.getCarPositionInCarList(car)" />
              <input v-if="!isSubscriptionPage" type="hidden" name="type" :value="getCarInfo(car.id).is_long_booking ? '4' : '1'">
              <input type="hidden" name="queryID" :value="car.__queryID" />
              <input type="hidden" name="userToken" :value="userToken" />
              <input type="hidden" name="listItemSource" :value="listItemSource" />
              <template v-if="!isSubscriptionPage">
                <input type="hidden" name="pickup_at" :value="pickupAt"  />
                <input type="hidden" name="delivery_at" :value="deliveryAt"/>
              </template>
              <button class="button-orange" id="selected-product" type="submit">{{ $t('layout.labels.subscription.continue') }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed bottom-0 left-0 right-0 py-3 px-6 bottom-0 left-0 w-full bg-white border-t z-50 left-0 right-0 mx-auto price-box md:py-7 max-w-[940px] !w-full lg:hidden lg:rounded-br-3xl lg:rounded-bl-3xl">
      <div class="flex justify-between items-center hover-btn-orange">
        <div v-if="isSubscriptionPage">
          <p class="text-sm text-dark-blue-2 font-normal leading-4 md:text-base">{{ $t('layout.subscription.from') }}
            <span class="font-bold text-base leading-5 md:text-2xl">{{ formatPrice(getCarTotalAmount(car)) }}</span>&nbsp; {{ $t('layout.subscription.price_per_month') }}
          </p>
          <span class="text-sm text-dark-blue-2 font-medium leading-4 md:text-base">{{ getCommitments(car) }}</span>
        </div>
        <div v-if="!isSubscriptionPage">
          <p class="text-lg text-dark-blue-2 font-normal leading-4 flex gap-2 md:text-base items-end">
            <span class="font-bold text-lg md:text-2xl !leading-none">{{ formatPrice(getCarTotalAmount(car, 'rental')) }}</span>
            <span v-if="getCarInfo(car.id).days_discount" class="text-xs text-light-blue-2 font-normal text-right line-through leading-[16.8px]">{{ formatPrice(Math.round(getCarTotalAmount(car, 'rental') - getCarInfo(car.id).days_discount_amount)) }}</span>
          </p>
          <span class="text-sm text-dark-blue-2 font-medium leading-4 md:text-base underline">{{ generateDateRange() }}</span>
        </div>
        <form @submit.prevent="trackActionAndSubmit('select_item', car, $event)" :action="getFormRoute()" method="GET">
          <input type="hidden" name="car_id" :value="car.id" />
          <input type="hidden" name="department_id" :value="this.getClosestDepartment(car).id" />
          <input type="hidden" name="car_position_in_list" :value="this.getCarPositionInCarList(car)" />
          <input v-if="!isSubscriptionPage" type="hidden" name="type" :value="getCarInfo(car.id).is_long_booking ? '4' : '1'">
          <input type="hidden" name="age" :value="this.age" />
          <input type="hidden" name="queryID" :value="car.__queryID" />
          <input type="hidden" name="userToken" :value="userToken" />
          <input type="hidden" name="listItemSource" :value="listItemSource" />
          <input v-if="isSubscriptionPage" type="hidden" name="starting_from" :value="getBookingStartingFrom()" />
          <template v-if="!isSubscriptionPage">
            <input type="hidden" name="pickup_at" :value="pickupAt"  />
            <input type="hidden" name="delivery_at" :value="deliveryAt"/>
          </template>
          <button class="button-orange" id="selected-product" type="submit">{{ $t('layout.labels.subscription.continue') }}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { momentify, dayjs } from "../../../../shared/js/dateUtils";
import GoogleRating from '../departments/GoogleRating.vue'

export default {
  name: 'CarModal',
  components: { GoogleRating },
  props: {
    car: {
      type: Object,
      required: true,
    },
    appLocale: {
      type: String,
      required: true
    },
    termsAndConditionContent: {
      type: String,
      required: true
    },
    isSubscriptionPage: {
      type: Boolean,
      required: true
    },
    termsAndConditionPage: {
      type: String,
      required: true
    },
    cancellationPolicyContent: {
      type: String,
      required: true
    },
    countryIso: {
      type: String,
      required: true
    },
    trustPilotBusinessId: {
      type: String,
      required: true
    },
    trustPilotLink: {
      type: String,
      required: true
    },
    mapsApiKey: {
      type: String,
      required: true,
    },
    carMileageUnits: {
      type: String,
      required: true,
    },
    postal: {
      type: String,
      required: true,
    },
    startingFrom: {
      type: String,
      required: false,
    },
    userToken: {
      type: String,
      required: false,
    },
    getCarInfo: {
      type: Function,
      required: false,
    },
    getCarTotalAmount: {
      type: Function,
      required: true,
    },
    getClosestDepartment: {
      type: Function,
      required: true,
    },
    getFormRoute: {
      type: Function,
      required: true,
    },
    getDepartmentName: {
      type: Function,
      required: true,
    },
    replaceByDefault: {
      type: Function,
      required: true,
    },
    toggleExpandable: {
      type: Function,
      required: true,
    },
    hideBookingTime: {
      type: Boolean
    },
    getCommitments: {
      type: Function,
      required: true,
    },
    getCarPositionInCarList: {
      type: Function,
      required: true,
    },
    getAvailableFrom: {
      type: Function,
      required: true,
    },
    pushDataLayer: {
      type: Function,
      required: true,
    },
    generateDateRange: {
      type: Function,
      required: true,
    },
    americanAddressFormat: {
      type: Boolean,
      required: false,
    },
    lengthUnit: {
      type: String,
      required: false,
    },
    lengthCalculationUnit: {
      type: String,
      required: false,
    },
    massUnit: {
      type: String,
      required: false,
    },
    showModal: {
      type: Function,
      required: true
    },
    sendEvent: {
      type: Function,
      required: true
    },
    sendImpressionClick: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      listItemSource: window.eecList,
      distanceUnitShort: window.distanceUnit,
      distanceUnitLong: window.distanceUnitLong,
      distanceUnitPlural: window.distanceUnitPlural,
      age: window.age,
      weekdayName: [
        {'day': 'Monday', 'index': 1},
        {'day': 'Tuesday', 'index': 2},
        {'day': 'Wednesday', 'index': 3},
        {'day': 'Thursday', 'index': 4},
        {'day': 'Friday', 'index': 5},
        {'day': 'Saturday', 'index': 6},
        {'day': 'Sunday', 'index': 0},
        {'day': 'Holiday', 'index': 'holiday'}
      ],
      measurements: {
        outside: {
          width: {
            text: window.i18next.t('layout.labels.subscription.width_a'),
            measurement: '',
          },
          height: {
            text: window.i18next.t('layout.labels.subscription.height_b'),
            measurement: '',
          },
          length: {
            text: window.i18next.t('layout.labels.subscription.length_c'),
            measurement: '',
          },
        },
        inside: {
          width: {
            text: window.i18next.t('layout.labels.subscription.width_d'),
            measurement: '',
          },
          height: {
            text: window.i18next.t('layout.labels.subscription.height_e'),
            measurement: '',
          },
          length: {
            text: window.i18next.t('layout.labels.subscription.length_f'),
            measurement: '',
          },
          capacity: {
            text: window.i18next.t('layout.labels.subscription.inside_capacity'),
            measurement: '',
          },
        }
      },
      seasonalPrices: {
        low_season_weekday: '',
        high_season_weekday: '',
        low_season_weekend: '',
        high_season_weekend: '',
        low_season_holiday: '',
        high_season_holiday: '',
      },
      hasSeasonalPrices: false,
      departmentGoogleData: {
        google_rating: 0,
        google_reviews_count: 0,
        google_reviews_link: null,
        isFetched: 0,
      },
      pickupAt: window.pickupAt,
      deliveryAt: window.deliveryAt,
      allowLocationWorkHoursBreaks: window.allowLocationWorkHoursBreaks,
    };
  },
  computed: {
    getCollectiveDaysTime() {
      let arrayIndex = 0;
      const weekDays = this.weekdayName.filter(day => day.index !== 0 && day.index !== 6 && day.index !== 'holiday');
      for(const dayObject of weekDays) {
        if (arrayIndex === 0) {
          arrayIndex++;
          continue;
        }
        if (this.getOpeningTime(dayObject.index) != this.getOpeningTime(this.weekdayName[arrayIndex - 1].index)) {
          return false;
        }
        arrayIndex++;
      }
      return this.getOpeningTime(weekDays[0].index);
    },
  },
  watch: {
    car(oldCar, currentCar) {
      this.measurements.outside.width.measurement = this.car.props.outside_width;
      this.measurements.outside.height.measurement = this.car.props.outside_height;
      this.measurements.outside.length.measurement = this.car.props.outside_length;

      this.measurements.inside.width.measurement = this.car.props.inside_width;
      this.measurements.inside.height.measurement = this.car.props.inside_height;
      this.measurements.inside.length.measurement = this.car.props.inside_length;
      this.measurements.inside.capacity.measurement = this.car.props.inside_size;
      this.seasonalPrices.low_season_weekday = this.car.seasonal_prices.calculated.low_week_day_price;
      this.seasonalPrices.high_season_weekday = this.car.seasonal_prices.calculated.high_week_day_price;
      this.seasonalPrices.low_season_weekend = this.car.seasonal_prices.calculated.low_weekend_price;
      this.seasonalPrices.high_season_weekend = this.car.seasonal_prices.calculated.high_weekend_price;
      this.seasonalPrices.low_season_holiday = this.car.seasonal_prices.calculated.low_special_day_price;
      this.seasonalPrices.high_season_holiday = this.car.seasonal_prices.calculated.high_special_day_price;
      this.hasSeasonalPrices = !this.getCarInfo(this.car.id).is_long_booking || this.isSubscriptionPage;
      if (oldCar.id !== currentCar.id) {
        this.getDepartmentGoogleRating()
      }
    }
  },
  mounted() {
    const self = this;
    $(document).on('click', ".all-feature-show", function() {
      $(".all-data-feature li.cursor-pointer").toggleClass("hidden");
      var isHidden = $(".all-data-feature li.hidden").length > 0;
      var text = isHidden ? window.i18next.t('layout.labels.subscription.show_all_features', {features_count:  self.car.features.length}) : window.i18next.t('layout.labels.subscription.show_less');
      var iconClass = isHidden ? "fa-chevron-down" : "fa-chevron-up";
      $(".all-feature-show").html(text + '<i class="fa-solid ' + iconClass + ' pl-2"></i>');
    });

  },
  methods: {
    trackActionAndSubmit(event, car, e) {
      this.sendImpressionClick(car);
      this.sendEvent('click', car, 'Item Added');
      this.pushDataLayer(event, car);
      e.currentTarget.submit();
    },
    getDepartmentGoogleRating() {
      let department = this.getClosestDepartment(this.car)
      if (!department.id) {
        return
      }

      this.departmentGoogleData.isFetched = 0
      $.get(window.getGoogleRatingUrl.replace('department', department.id)).then(response => {
        this.departmentGoogleData.google_rating = response.google_rating
        this.departmentGoogleData.google_reviews_count = response.google_reviews_count
        this.departmentGoogleData.google_reviews_link = response.google_reviews_link
        this.departmentGoogleData.isFetched = 1
      }, () => {
        this.departmentGoogleData.google_rating = 0
        this.departmentGoogleData.google_reviews_count = 0
        this.departmentGoogleData.google_reviews_link = null
        this.departmentGoogleData.isFetched = 1
      });
    },
    hasAgeRestriction() {
      return this.car.props && this.car.props !== 'undefined' && this.car.props.hasOwnProperty('age_restriction');
    },
    hasExtraDriverPrice() {
      return this.car.props && this.car.props !== 'undefined' && this.car.props.hasOwnProperty('extra_driver_price');
    },
    getPickupTime(date) {
      const openingTiming = this.getClosestDepartment(this.car).opening_timing;
      const dayId = momentify(date).day();
      if (openingTiming.length > 0) {
        const day = openingTiming.find(timing => timing.day === dayId + "");
        if (!day.is_closed) {
          return day.pickup;
        }
        return '08:30:00';
      }
      return '08:30:00';
    },
    formatTime(time) {
      return dayjs(time, 'HH:mm:ss').format(window.jsTimeFormat)
    },
    getOpeningTime(index) {
      const openingTiming = this.getClosestDepartment(this.car).opening_timing;

      if (openingTiming.length > 0) {
        const day = openingTiming.find(timing => timing.day === index.toString());

        if (day) {
          if (day.is_closed === true) {
            return this.$t('layout.labels.subscription.pickup_location.closed');
          }
          let hours = ''
          if (day.open) {
            hours = this.formatTime(day.open) + ' - ';
          }

          if (this.allowLocationWorkHoursBreaks && day.break_start && day.break_end) {
            hours += `${this.formatTime(day.break_start)},<br /> ${this.formatTime(day.break_end)} - `
          }

          if (day.close) {
            hours += this.formatTime(day.close);
          }

          return hours;
        }
      }
      return this.$t('layout.labels.subscription.pickup_location.closed');
    },
    hasInsideMeasurements() {
      const hasImages = this.car.type && this.car.type !== 'undefined' && this.car.type.inside_measurement_images && this.car.type.inside_measurement_images.length > 0;
      const hasMeasurements = this.car.props.inside_width !== undefined || this.car.props.inside_length !== undefined || this.car.props.inside_height !== undefined;

      return hasImages && hasMeasurements;
    },

    hasOutterMeasurements() {
      const hasImages = this.car.type && this.car.type !== 'undefined'&& this.car.type.outside_measurement_images && this.car.type.outside_measurement_images.length > 0;
      const hasMeasurements = this.car.props.outside_width !== undefined || this.car.props.outside_length !== undefined || this.car.props.outside_height !== undefined;

      return hasImages && hasMeasurements;
    },
    getBookingStartingFrom() {
      const carAvailableFrom = this.getAvailableFrom(this.car);
      return momentify(carAvailableFrom + ` ${this.getPickupTime(carAvailableFrom)}`).format('YYYY-MM-DD HH:mm:ss');
    },
  }
}
</script>

<style scoped>
.last-item {
  margin-bottom: 7rem;
}
@media (min-width: 767px) {
  .last-item {
    margin-bottom: 4rem;
  }
}
</style>
